// extracted by mini-css-extract-plugin
module.exports = {"asosFocus":"_32fTTcX","list":"_3hrLByJ","list__animate":"_3xzM4ms","carouselLink":"Z-Lxgd1 _32fTTcX"};